import { useState, useEffect } from 'react';
import { TRACKING_EVENTS, trackEventWithData } from 'helpers';

const useZoomSupportCheck = () => {
  const [isZoomWorking, setIsZoomWorking] = useState<boolean | null>(null);

  useEffect(() => {
    const checkZoomSupport = () => {
      try {
        const testEl = document.createElement('div');
        testEl.style.zoom = '0.5';
        const supported = testEl.style.zoom === '0.5';
        const isSafari = navigator.userAgent.includes('Safari');

        // Test if zoom actually works
        let working = false;
        if (supported) {
          testEl.style.width = '100px';
          testEl.style.position = 'absolute';
          testEl.style.visibility = 'hidden';

          document.body.appendChild(testEl);
          // Get actual visual position and size
          const rect = testEl.getBoundingClientRect();

          if (isSafari) {
            const computedWidth = parseFloat(getComputedStyle(testEl).width);
            const zoom = parseFloat(window.getComputedStyle(testEl).zoom);
            const actualWidth = computedWidth * zoom;
            working = actualWidth === 50;
          } else {
            working = rect.width === 50;
          }

          document.body.removeChild(testEl);
        }

        setIsZoomWorking(working);

        trackEventWithData(TRACKING_EVENTS.ZoomSupportCheck, {
          working: working,
        });
      } catch (error) {
        trackEventWithData(TRACKING_EVENTS.ZoomSupportCheck, {
          working: false,
        });
        setIsZoomWorking(false);
      }
    };

    checkZoomSupport();
  }, []);

  return { isZoomWorking };
};

export default useZoomSupportCheck;
